<template>
  <div id="statisticalNoBooth">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'statisticalNoBooth'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/statistical/exhibition/booth/StatisNoBooth.vue